import { each, set } from 'lodash';

class FormSerializer {
    static serialize(form, removeNull = false) {
        const inputs = form.elements;
        const data = {};
        each(inputs, (prop, key) => {
            // eslint-disable-next-line no-prototype-builtins
            if (inputs.hasOwnProperty(key)) {
                if (prop.name !== '' && prop.value !== null) {
                    if (prop.type === 'checkbox') {
                        if (prop.checked) {
                            if (prop.multiple) {
                                if (prop.value) {
                                    if (typeof data[prop.name] === 'undefined') data[prop.name] = [];
                                    data[prop.name].push(prop.value);
                                }
                            } else {
                                data[prop.name] = prop.value ? prop.value : null;
                            }
                        }
                    } else {
                        if (prop.name === 'email') {
                            prop.value = prop.value.toLowerCase();
                        }

                        if (removeNull) {
                            if (prop.value) {
                                set(data, prop.name, prop.value || null);
                            }
                        } else {
                            set(data, prop.name, prop.value || null);
                        }
                    }
                }
            }
        });
        return data;
    }
}

export default FormSerializer;
